module.exports = __webpack_public_path__ + "img/T4-A-rc_13.a5e508c8.png";